import React, { useState, useEffect, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-scroll"
import { FaSun, FaMoon } from "react-icons/fa"

const navbarItems = [
  {
    id: "aboutme",
    name: "About",
  },
  {
    id: "skills",
    name: "Skills",
  },
  {
    id: "projects",
    name: "Projects",
  },
  {
    id: "contactme",
    name: "Contact",
  },
]

function Hamburger({ isActive, toggleActive }) {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      role="button"
      className={classnames("navbar-burger", { "is-active": isActive })}
      data-target="navMenu"
      aria-label="menu"
      aria-expanded="false"
      onClick={() => toggleActive(!isActive)}
    >
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  )
}

function ToggleTheme({ className, theme, toggleTheme }) {
  return (
    <div className={classnames("switch-container", className)}>
      <label
        className="switch"
        title={theme === "dark" ? "Toggle Light Mode" : "Toggle Dark Mode"}
      >
        <span
          className={classnames("theme-icon", {
            "icon-dark": theme === "dark",
          })}
        >
          {theme === "light" ? <FaSun /> : <FaMoon />}
        </span>
        <input
          type="checkbox"
          checked={theme === "dark"}
          onChange={() => toggleTheme(theme === "light" ? "dark" : "light")}
        />
        <span className="slider round"></span>
      </label>
    </div>
  )
}

function Navbar({ theme, toggleTheme }) {
  const [isActive, toggleActive] = useState(false)
  const navbarRef = useRef()
  useEffect(() => {
    let prevScrollpos = window.pageYOffset
    window.onscroll = function() {
      const currentScrollPos = window.pageYOffset
      const navbarHeight = navbarRef.current.getBoundingClientRect().height
      if (prevScrollpos > currentScrollPos) {
        navbarRef.current.style.top = 0
      } else {
        navbarRef.current.style.top =
          prevScrollpos > 0.25 * window.innerHeight ? `-${navbarHeight}px` : 0
      }
      prevScrollpos = currentScrollPos
    }
  }, [])
  return (
    <nav
      ref={navbarRef}
      className={classnames(
        "navbar is-fixed-top",
        { "is-dark": theme === "dark" },
        { "navbar-is-active": isActive }
      )}
    >
      <div className="navbar-brand">
        <Hamburger isActive={isActive} toggleActive={toggleActive} />
        <ToggleTheme
          className="is-hidden-tablet toggle-btn-mobile"
          theme={theme}
          toggleTheme={toggleTheme}
        />
      </div>
      <div
        id="navBar"
        className={classnames("navbar-menu", { "is-active": isActive })}
      >
        <div className="navbar-end">
          {navbarItems.map(navbarItem => (
            <Link
              key={navbarItem.id}
              className="navbar-item"
              to={navbarItem.id}
              duration={500}
              onClick={() => toggleActive(false)}
              smooth
            >
              {navbarItem.name}
            </Link>
          ))}
          <a
            className="navbar-item"
            href="https://drive.google.com/open?id=1BUYHT11ewvvkvW0ezzR0VEKWr8YWqzNO"
            target="__blank"
            rel="noreferrer noopener"
          >
            Resume
          </a>
          <ToggleTheme
            className="is-hidden-mobile navbar-item"
            theme={theme}
            toggleTheme={toggleTheme}
          />
        </div>
      </div>
    </nav>
  )
}

export default Navbar
